import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Bone = ({ className = '' }) => <span className={`today-skeleton ${className}`} />;

export function MetricSkeleton() {
  return (
    <Col xs={4}>
      <div className="bg-white border rounded p-2 text-center">
        <Bone className="today-skeleton--metric d-block mx-auto mb-1" />
        <Bone className="today-skeleton--label d-block mx-auto" />
      </div>
    </Col>
  );
}

export function TodayCardSkeleton() {
  return (
    <Col md={6} xl={4} className="mb-3">
      <article className="today-card today-skeleton-card card shadow-sm" aria-hidden>
        <div className="today-skeleton today-skeleton--accent" />
        <div className="card-body">
          <div className="d-flex">
            <Bone className="today-skeleton--priority mr-2" />
            <div className="flex-fill min-width-0">
              <div className="d-flex align-items-center">
                <Bone className="today-skeleton--name" />
                <Bone className="today-skeleton--badge ml-2" />
              </div>
              <Bone className="today-skeleton--line mt-2" />
              <Bone className="today-skeleton--line today-skeleton--short mt-2" />
            </div>
          </div>
        </div>
        <div className="today-skeleton-actions d-flex border-top">
          {['call', 'reached', 'note', 'complete'].map(action => (
            <div key={action} className="flex-fill d-flex justify-content-center">
              <Bone className="today-skeleton--action" />
            </div>
          ))}
        </div>
      </article>
    </Col>
  );
}

export function StatButtonSkeleton() {
  return (
    <Col xs={6} md className="mb-2">
      <div className="today-skeleton-card border bg-white rounded text-left w-100 px-3 py-2" aria-hidden>
        <Bone className="today-skeleton--stat d-block mb-2" />
        <Bone className="today-skeleton--label d-block" />
      </div>
    </Col>
  );
}

export function SectionHeaderSkeleton() {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3" aria-hidden>
      <Bone className="today-skeleton--heading" />
      <Bone className="today-skeleton--badge" />
    </div>
  );
}

export function PipelineCardSkeleton() {
  return (
    <Col md={6} xl={4} className="mb-3">
      <div className="today-skeleton-card border rounded d-flex align-items-center p-3 h-100 bg-white" aria-hidden>
        <div className="flex-fill min-width-0">
          <Bone className="today-skeleton--name" />
          <Bone className="today-skeleton--line today-skeleton--short mt-2" />
        </div>
        <Bone className="today-skeleton--icon ml-2" />
        <Bone className="today-skeleton--chevron ml-2" />
      </div>
    </Col>
  );
}

export function MoneyCardSkeleton() {
  return (
    <Col md={6} xl={4} className="mb-3">
      <div className="today-skeleton-card bg-white border rounded p-3 h-100" aria-hidden>
        <div className="d-flex align-items-start">
          <div className="flex-fill min-width-0">
            <div className="d-flex align-items-center">
              <Bone className="today-skeleton--name" />
              <Bone className="today-skeleton--badge ml-2" />
            </div>
            <Bone className="today-skeleton--line today-skeleton--short mt-2" />
            <Bone className="today-skeleton--line mt-2" />
            <Bone className="today-skeleton--line today-skeleton--short mt-2" />
          </div>
          <Bone className="today-skeleton--chevron ml-2" />
        </div>
      </div>
    </Col>
  );
}

export function CardSkeletonGrid({ count = 6, Card }) {
  return (
    <Row>
      {Array.from({ length: count }, (_, index) => (
        <Card key={index} />
      ))}
    </Row>
  );
}

export function LoadingStatus({ label }) {
  return (
    <span className="sr-only" role="status">
      {label}
    </span>
  );
}
